var _style, _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCvnaIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 881.2 881.2",
    style: {
      enableBackground: "new 0 0 881.2 881.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#01ACD8;}\n\t.st1{fill:#FFFFFF;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 440.3,
    cy: 441.1,
    r: 440.6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M240.3,411.8h-41.7c-0.8-5.4-2.3-10.2-4.7-14.4c-2.3-4.2-5.4-7.8-9-10.8c-3.7-3-7.9-5.3-12.7-6.9 c-4.8-1.6-10-2.4-15.6-2.4c-10.1,0-18.9,2.5-26.4,7.5c-7.5,5-13.3,12.2-17.4,21.7c-4.1,9.5-6.2,21-6.2,34.5c0,13.9,2.1,25.6,6.2,35 c4.2,9.5,10,16.6,17.5,21.4c7.5,4.8,16.2,7.2,26,7.2c5.5,0,10.6-0.7,15.4-2.2c4.7-1.5,8.9-3.6,12.6-6.4c3.7-2.8,6.7-6.3,9.2-10.3 c2.4-4.1,4.1-8.7,5.1-13.9l41.7,0.2c-1.1,9-3.8,17.6-8,25.9c-4.3,8.3-10,15.7-17.2,22.2c-7.2,6.5-15.8,11.7-25.7,15.4 c-9.9,3.8-21.2,5.7-33.7,5.7c-17.4,0-32.9-3.9-46.6-11.8c-13.7-7.9-24.5-19.3-32.4-34.2c-7.9-14.9-11.9-33-11.9-54.2 c0-21.3,4-39.4,12-54.3c8-14.9,18.9-26.3,32.6-34.1c13.7-7.8,29.1-11.8,46.3-11.8c11.3,0,21.8,1.6,31.5,4.8 c9.7,3.2,18.3,7.8,25.8,13.9c7.5,6.1,13.6,13.5,18.3,22.2C236,390.5,239,400.5,240.3,411.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M295.5,343.5l47.1,148.2h1.8l47.2-148.2h45.7l-67.2,195h-53.1l-67.3-195H295.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M614.4,343.5v195h-35.6l-84.9-122.8h-1.4v122.8h-41.2v-195h36.2l84.2,122.7h1.7V343.5H614.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M672.3,538.6h-44.2l67.3-195h53.1l67.2,195h-44.2l-48.9-150.5h-1.5L672.3,538.6z M669.6,461.9h104.4v32.2 H669.6V461.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCvnaIcon);
export default __webpack_public_path__ + "static/media/cvna_icon.747b789924ccba88b5464e19dd7b5c4c.svg";
export { ForwardRef as ReactComponent };